// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c-nun","left":"styles_left__1gY38","desktopActions":"styles_desktopActions__30HkW","title":"styles_title__1zRRf"};